<mat-chip [attr.data-automation-id]="'search-filter-chip-' + title"
          disableRipple
          class="smt-search-filter-chip"
          [class.smt-search-toggle-chip]="(widget.getDisplayValue() | async) || menuTrigger.menuOpen"
          [class.smt-search-toggle-chip-error]="(widget.getDisplayError() | async)"
          [class.smt-search-toggle-chip-not-editable]="!editable"
          [matMenuTriggerFor]="menu"
          (onMenuOpen)="onMenuOpen()"
          #menuTrigger="matMenuTrigger">
    <span class="smt-search-filter-placeholder">
        <span class="smt-search-filter-ellipsis">{{ title | translate }}</span>
        <ng-container *ngIf="widget.getDisplayValue() | async">:</ng-container>
    </span>
    <span class="smt-search-filter-ellipsis" *ngIf="widget.getDisplayValue() | async as columnValue" [matTooltip]="columnValue.tooltip">
        &nbsp;{{ columnValue.value }}
    </span>
    <mat-icon>keyboard_arrow_down</mat-icon>
</mat-chip>

<mat-menu [class]="filter.search?.class" #menu="matMenu" backdropClass="smt-search-filter-chip-menu" (closed)="onClosed()">
    <div #menuContainer [attr.data-automation-id]="'search-field-' + title">
        <smt-search-filter-menu-card [showActions]="editable"
                                     (click)="$event.stopPropagation()"
                                     (keydown.tab)="$event.stopPropagation();"
                                     (closeMenu)="menuTrigger.closeMenu()">

            <ng-container ngProjectAs="filter-title">
                {{ 'ALDEN.CUSTOM_LISTS.FILTERS.HEADER_TEXT' | translate }} {{ title | translate }}
            </ng-container>

            <ng-container ngProjectAs="filter-content">
                <smt-search-widget-container #widget [filter]="filter">
                </smt-search-widget-container>
            </ng-container>

            <ng-container *ngIf="editable" ngProjectAs="filter-actions">
                <button mat-flat-button class="smt-search-action-button" color="accent" (click)="onRemove()" id="cancel-filter-button">
                    {{ 'SEARCH.FILTER.BUTTONS.REMOVE' | translate }}
                </button>
                <button mat-flat-button class="smt-search-action-button" color="primary" (click)="onApply()" id="apply-filter-button" [disabled]="!hasValidValue()">
                    {{ 'SEARCH.FILTER.BUTTONS.APPLY' | translate }}
                </button>
            </ng-container>
        </smt-search-filter-menu-card>
    </div>
</mat-menu>
